import * as tslib_1 from "tslib";
import { View } from '@swim/ui';
import { GeometryView } from './geometry-view';
var LayerView = (function (_super) {
    tslib_1.__extends(LayerView, _super);
    function LayerView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayerView.prototype.addLayer = function (layer) {
        this.appendChildView(layer);
    };
    LayerView.prototype.removeLayer = function (layer) {
        this.appendChildView(layer);
    };
    LayerView.prototype.addGeometry = function (geometry) {
        this.appendChildView(geometry);
    };
    LayerView.prototype.removeGeometry = function (geometry) {
        this.appendChildView(geometry);
    };
    LayerView.prototype.collectFeatures = function (features) {
        for (var i = 0; i < this._childViews.length; i += 1) {
            var childView = this._childViews[i];
            if (childView instanceof LayerView) {
                childView.collectFeatures(features);
            }
            else if (childView instanceof GeometryView) {
                features.push(childView.toGeoJson());
            }
        }
    };
    LayerView.prototype.toGeoJson = function () {
        var features = [];
        this.collectFeatures(features);
        return {
            type: 'FeatureCollection',
            features: features,
        };
    };
    return LayerView;
}(View));
export { LayerView };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF5ZXItdmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxheWVyLXZpZXcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxJQUFJLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFDOUIsT0FBTyxFQUFDLFlBQVksRUFBQyxNQUFNLGlCQUFpQixDQUFDO0FBRzdDO0lBQXdDLHFDQUFJO0lBQTVDOztJQW9DQSxDQUFDO0lBbkNDLDRCQUFRLEdBQVIsVUFBUyxLQUFnQjtRQUN2QixJQUFJLENBQUMsZUFBZSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzlCLENBQUM7SUFFRCwrQkFBVyxHQUFYLFVBQVksS0FBZ0I7UUFDMUIsSUFBSSxDQUFDLGVBQWUsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM5QixDQUFDO0lBRUQsK0JBQVcsR0FBWCxVQUFZLFFBQXNCO1FBQ2hDLElBQUksQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDakMsQ0FBQztJQUVELGtDQUFjLEdBQWQsVUFBZSxRQUFzQjtRQUNuQyxJQUFJLENBQUMsZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ2pDLENBQUM7SUFFRCxtQ0FBZSxHQUFmLFVBQWdCLFFBQW1DO1FBQ2pELEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDO1lBQ3BELElBQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDdEMsRUFBRSxDQUFDLENBQUMsU0FBUyxZQUFZLFNBQVMsQ0FBQyxDQUFDLENBQUM7Z0JBQ25DLFNBQVMsQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFDLENBQUM7WUFDdEMsQ0FBQztZQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxTQUFTLFlBQVksWUFBWSxDQUFDLENBQUMsQ0FBQztnQkFDN0MsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxFQUFFLENBQUMsQ0FBQztZQUN2QyxDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUM7SUFFRCw2QkFBUyxHQUFUO1FBQ0UsSUFBTSxRQUFRLEdBQUcsRUFBK0IsQ0FBQztRQUNqRCxJQUFJLENBQUMsZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQy9CLE1BQU0sQ0FBQztZQUNMLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFLFFBQVE7U0FDbkIsQ0FBQztJQUNKLENBQUM7SUFDSCxnQkFBQztBQUFELENBQUMsQUFwQ0QsQ0FBd0MsSUFBSSxHQW9DM0MifQ==